export const timeToProtobufDuration = (timeStr: string) => {
    const parts = timeStr.split(':').map(Number);

    let hours = 0,
        minutes = 0,
        seconds = 0,
        milliseconds = 0;

    if (parts.length >= 1) {
        hours = parts[0] || 0;
    }

    if (parts.length >= 2) {
        minutes = parts[1] || 0;
    }

    if (parts.length >= 3) {
        const secParts = String(parts[2]).split('.');

        seconds = Number(secParts[0]) || 0;
        milliseconds = secParts[1] ? Number((secParts[1] + '000').slice(0, 3)) : 0;
    }

    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    const nanos = milliseconds * 1_000_000;

    if (nanos === 0) {
        return `${totalSeconds}s`;
    } else {
        const nanosStr = String(nanos).padStart(9, '0'); // 9 цифр

        return `${totalSeconds}.${nanosStr}s`;
    }
};

export const protobufDurationToTime = (durationStr?: string) => {
    if (!durationStr) {
        return undefined;
    }

    const clean = durationStr.replace(/s$/, '');
    const [secondsPart] = clean.split('.');

    let totalSeconds = Number(secondsPart) || 0;
    const hours = Math.floor(totalSeconds / 3600);

    totalSeconds %= 3600;

    const minutes = Math.floor(totalSeconds / 60);

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};
